import API from '../infraestructure/api';
import ApiError from './apiError';

export async function getServiceRoles(data = '') {
  try {
    const response = await API.get(`/rol${data}`);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/roles/', message: `Hubo un problema al intentar buscar roles. ${message}` });
  }
}

export async function getServiceAnalisisRoles(data) {
  try {
    const response = await API.get(`/analisisrol?rol_id=${data}`);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/roles/', message: `Hubo un problema al intentar buscar analisis rol. ${message}` });
  }
}
export async function postServiceAnalisisRoles(data) {
  try {
    const response = await API.post('/analisisrol', data);
    if (response && response.headers && response.headers.location) {
      return response.headers.location;
    }
    return '';
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/analisis/', message: `Hubo un problema al intentar crear analisis. ${message}` });
  }
}

export async function postServiceRole(data) {
  try {
    const response = await API.post('/rol', data);
    if (response && response.headers && response.headers.location) {
      return response.headers.location;
    }
    return '';
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/rol/', message: `Hubo un problema al intentar crear Rol. ${message}` });
  }
}

export async function putServiceAnalisisRoles(data) {
  try {
    const response = await API.put('/analisisrol', data);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/analisis/', message: `Hubo un problema al intentar editar analisis. ${message}` });
  }
}

export async function putServiceRole(data) {
  try {
    const response = await API.put('/rol', data);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/rol/', message: `Hubo un problema al intentar editar un Rol. ${message}` });
  }
}
